import React from 'react';
import io from 'socket.io-client';
import ChannelList from '../../channels.json';
import { ChannelMeta } from '../ChannelMeta';
import { ChannelLogo } from '../ChannelLogo';

class ChannelDetail extends React.Component {

  // toon ChannelLogo of ChannelMeta
  // in deze component maken we verbinding met de socket

  state = {
    metaData: {},
    episodeData: {}
  }

  componentDidMount() {

    if (this.props.channelCode) {
      const channelCode = this.props.channelCode;

      //By default, a long-polling connection is established first, then upgraded to "better" transports (like WebSocket). 
      //If you like to live dangerously, this part can be skipped:
      // deze aanpassingen zorgen ervoor dat de applicatie werkt in Safari
      this.socket = io('https://api.vrt.radio', {
        transports: ['websocket']
      });

      // on reconnection, reset the transports option, as the Websocket
      // connection may have failed (caused by proxy, firewall, browser, ...)
      this.socket.on('reconnect_attempt', () => {
        this.socket.io.opts.transports = ['polling', 'websocket'];
      });
      
      this.socket.on('now-on-air', (data) =>{
        this.setState(
          { metaData: data[channelCode]},
          // the second parameter to setState will be called on completion, so you'll log every time the speed changes
          () => {
            this.props.updateStylingHandler(data[channelCode], 'SONG');
          }
        )
      });
      

      this.socket.on(
        'EpisodeUpdate', 
        data => 
          this.setState(
            { episodeData: data },
            // the second parameter to setState will be called on completion, so you'll log every time the speed changes
            () => {
              
              this.props.updateStylingHandler(data[channelCode], 'EPISODE');
            }
          )
      );
    }

  }

  componentWillUnmount() {
    this.socket.close();
  }

  render() {

    let channelDetails;
    let logoUrl;
    let placeholderUrl;
    let channelId;
    let imgStyle;

    if (this.props.channelCode) {
      // we kunnen pas verbinden met de socket indien we de channel-code hebben


      
      //find channel details for selected channel-code in ChannelList
      for (let i = 0; i < ChannelList.length; i++) {
        if (ChannelList[i].id === this.props.channelCode) {
          channelDetails = ChannelList[i];
          break;
        }
      }
      //check if channelDetails are found
      if (typeof channelDetails === 'object') {
        logoUrl = 'img/channelImages/' + channelDetails.logo;
        placeholderUrl = 'img/channelPlaceholders/' + channelDetails.link + '.jpg';
        channelId = channelDetails.id;
        imgStyle = {
          maxWidth: '20vw', 
        }
      }
    }

    if (typeof logoUrl !== 'string') {
      //select randon channel
      let min = Math.ceil(1);
      let max = Math.floor(ChannelList.length);
      let random = Math.floor(Math.random() * (max - min)) + min;
      logoUrl = 'img/channelImages/' + ChannelList[random-1].logo;
    }

    
    const styles = {
      textAlign: 'center',
      margin: 0,
      padding: 0,
      color: "white"
    }

    if (this.state) {  
      return <ChannelMeta channelCode={this.props.channelCode} metaData={this.state} channelId={channelId} placeholderUrl={placeholderUrl} logoUrl={logoUrl} imgStyle={imgStyle} styles={styles} />
    } else {
      return <ChannelLogo logoUrl={logoUrl} imgStyle={imgStyle} styles={styles} />
    }
  }
}

export default ChannelDetail;